let _ = require('../_.js');
var $ = jQuery;

// Functions for reflecting the status of websocket to the admin.

// Abstracted here because this is a seperate level of concern from the actual connection interface.

// The only logic right now is to show a flash message and an error badge on disconnect, or failure to connect after 20 seconds.

// TODO: SHOW THE ERROR BADGE

_.ac_websocket_ui_init = function () {

    let error_showing = false;
    let error_timer = null;
    let connection_timeout = 10 * 1000;

    let show_error = function () {
        error_showing = true;
        if ($(".ac-component-ws-critical").length) {

            $(".ac-component-ws-critical").each(function () {
                var $this = $(this);
                if ($this.find('.ws-connection-overlay').length) {
                    $this.find('.ws-connection-overlay').css({
                        'position': 'absolute',
                        'top': $this.position().top,
                        'left': $this.position().left,
                        'width': $this.outerWidth(),
                        'height': $this.outerHeight(),
                    });
                } else {
                    var $overlay = $("<div class='ws-connection-overlay'>Connection interupted<br /><br />Reconnecting...</div>");

                    $overlay.css({
                        'position': 'absolute',
                        'top': $this.position().top,
                        'left': $this.position().left,
                        'width': $this.outerWidth(),
                        'height': $this.outerHeight(),
                        'background-color': 'rgba(0, 0, 0, 0.82)',
                        'color': 'white',
                        'font-size': '18pt',
                        'font-weight': 'bold',
                        'display': 'flex',
                        'align-items': 'center',
                        'justify-content': 'center',
                        'z-index': 1000,
                        'display': 'flex',
                        'text-align': 'center'
                    });

                    $overlay.hide();
                    $this.append($overlay);
                    $overlay.fadeIn();
                }
            });
        }
    }

    let hide_error = function () {
        error_showing = false;
        if ($(".ac-component-ws-critical").length) {
            _.flash_alert("Server connected!", 'success');
            $(".ac-component-ws-critical").each(function () {
                var $this = $(this);

                $this.find('.ws-connection-overlay').fadeOut(function () {
                    $(this).remove();
                });
            });
        }
        // $(".clerk-header-websocket-disconnected").fadeOut();
    }

    let delay_show_error = function () {
        if (error_timer === null) {
            error_timer = setTimeout(function () {
                if (!error_showing) {
                    error_showing = true;
                    _.flash_alert("Connection interupted, reconnecting...", "secondary");
                    show_error();
                    $(".clerk-header-websocket-disconnected").fadeIn();
                }
            }, connection_timeout);
        }
    }

    _.on_websocket_connecting(function () {
        delay_show_error();
    });

    _.on_websocket_connected(function () {
        clearTimeout(error_timer);
        error_timer = null;
        if (error_showing) {
            hide_error();
        }
    });

    _.on_websocket_disconnected(function () {
        delay_show_error();
    })

    _.on_ui_resize(function () {
        if (error_showing) {
            show_error();
        }
    });
}